// extracted by mini-css-extract-plugin
export default {"popover":"JYo8eTF5Ar7mv996u2rt"};